import moment from 'moment'

export const statusOptions = [
  { text: 'Active', value: 'Active' },
  { text: 'Sold', value: 'Sold' }
]

// export const propertyOptions = [
//   { text: 'Residential', value: 'residential' },
//   { text: 'Lease', value: 'lease' }
// ]

export const stateOptions = [
  { text: 'California', value: 'CA' },
  { text: 'New York', value: 'NY' },
  { text: 'Texas', value: 'TX' }
]

// TODO: Break these up into residential and residentiallease
export const subPropertyOptions = [
  // { text: 'Attached 1/2 Duplex', value: 'hduplx' },
  { text: 'Condominium', value: 'Condominium' },
  // { text: 'House', value: 'house' },
  // { text: 'Modular', value: 'modular' },
  { text: 'ManufacturedHome', value: 'ManufacturedHome' },
  { text: 'MobileHome', value: 'MobileHome' },
  { text: 'SingleFamilyResidence', value: 'SingleFamilyResidence' },
  { text: 'Townhouse', value: 'Townhouse' },
  { text: 'Farm', value: 'Farm' },
  { text: 'UnimprovedLand', value: 'UnimprovedLand' }
  // { text: 'See Agent', value: 'agent' }
]

export const listingOptions = [
  { text: 'Foreclosure', value: 'foreclosure' },
  { text: 'Pending Listings', value: 'pending' }
]

export const petOptions = [
  // { text: 'Cats Allowed', value: 'cats' },
  // { text: 'Dogs Allowed', value: 'dogs' },
  { text: 'Pets Allowed', value: 'nopets' }
]

export const amenityOptions = [
  { text: 'Unit Washer/Dryer', value: 'washer' },
  { text: 'Air Conditioning', value: 'air' },
  { text: 'Microwave', value: 'microwave' },
  { text: 'Dishwasher', value: 'dishwasher' },
  { text: 'Garage', value: 'garage' },
  { text: 'Disposal', value: 'disposal' },
  { text: 'Pool/Hot Tub', value: 'tub' },
  { text: 'Balcony', value: 'balcony' },
  { text: 'Gym', value: 'gym' },
  { text: 'Fireplace', value: 'fireplace' }
]

export const dropdownNoOfBeds = [
  { text: 'Any', value: '' },
  { text: '1+', value: '1' },
  { text: '2+', value: '2' },
  { text: '3+', value: '3' },
  { text: '4+', value: '4' }
]

export const dropdownNoOfBaths = [
  { text: 'Any', value: '' },
  { text: '1+', value: '1' },
  { text: '2+', value: '2' },
  { text: '3+', value: '3' },
  { text: '4+', value: '4' }
]

export const housingOptions = [
  { text: 'Furnished', value: 'furnished' },
  { text: 'Income Restricted', value: 'income' }
]

export const sortOptions = [
  { text: 'Price $-$$', value: 0 },
  { text: 'Price $$-$', value: 1 },
  { text: 'Beds', value: 2 },
  { text: 'Baths', value: 3 },
  { text: 'Footage', value: 4 },
  { text: 'Acreage', value: 5 },
  { text: 'Reducations', value: 6 },
  { text: 'Days on Website', value: 7 },
  { text: '# Pictures', value: 8 },
  { text: 'Walk Score', value: 9 },
  { text: 'Popularity', value: 10 }
]

export const layoutOptions = [
  { text: 'Grid', value: 0 },
  { text: 'List', value: 1 },
  { text: 'Map', value: 2 }
]

export const salePrices = () => {
  let minArr = []
  for (let i = 50000; i < 500000; i += 50000) {
    minArr.push(i.toString())
  }
  for (let i = 500000; i < 1000000; i += 100000) {
    minArr.push(i.toString())
  }
  for (let i = 1000000; i < 6000000; i += 1000000) {
    minArr.push(i.toString())
  }
  return minArr
}

export const rentPrices = () => {
  let minArr = []
  for (let i = 500; i <= 1500; i += 200) {
    minArr.push(i)
  }
  for (let i = 2000; i <= 5000; i += 1000) {
    minArr.push(i)
  }
  minArr.push(10000)
  minArr.push(20000)
  return minArr
}

export const areaOptions = () => {
  let minArr = []
  minArr.push({
    text: 'No min',
    value: ''
  })
  for (let i = 200; i < 2000; i += 200) {
    minArr.push({
      text: i.toString(),
      value: i.toString()
    })
  }
  for (let i = 2000; i <= 10000; i += 1000) {
    minArr.push({
      text: i.toString(),
      value: i.toString()
    })
  }
  minArr.push({
    text: '15000',
    value: '15000'
  })
  return minArr
}

export const lotSizeOptions = () => {
  let minArray = []
  minArray.push({
    text: 'No min',
    value: ''
  })
  for (let i = 1; i < 10; i++) {
    let decimalValue = (i / 10).toString()
    // if (decimalValue.includes('.')) {
    //   decimalValue = decimalValue.substr(decimalValue.indexOf('.'))
    // }
    // console.log(decimalValue)
    minArray.push({
      text: decimalValue,
      value: decimalValue
    })
  }
  for (let i = 1; i <= 20; i++) {
    let decimalValue = (i / 2).toString()
    minArray.push({
      text: decimalValue,
      value: decimalValue
    })
  }
  return minArray
}

export const yearOptions = () => {
  const currentYear = moment().year()
  let minArray = []
  minArray.push({
    text: 'No min',
    value: ''
  })
  minArray.push({
    text: '< 1900',
    value: '0'
  })
  for (let i = 1900; i <= currentYear; i++) {
    minArray.push({
      text: i.toString(),
      value: i.toString()
    })
  }
  return minArray
}

export const INITIAL_SEARCH_QUERY = {
  Status: 'Closed', // TODO: 'Active',
  MLSNumber: '',
  Beds: '',
  Baths: '',
  PropertyType: '',
  PropertySubType: '',
  City: '',
  StateOrProvince: '',
  PostalCode: '',
  Price: '',
  SqFt: ''
}

// An estimated new search query params
export const INITIAL_NEW_QUERY = {
  Status: 'Closed', // TODO: 'Active',
  MLSNumber: '',
  Beds: '',
  Baths: '',
  PropertyType: 'Residential',
  PropertySubType: '',
  StreetNumber: '',
  StreetName: '',
  StreetSuffix: '',
  City: '',
  StateOrProvince: '',
  PostalCode: '',
  Price: '',
  SqFt: '',
  LotSizeArea: '',
  YearBuilt: '',
  Foreclosure: false,
  Keywords: ''
  // Listings: [],
  // Pets: [],
  // Amenities: [],
  // Housing: []
}

export const SEARCH_LIMIT = 30

// Temporary object for new sale/rent search layout
export const searchOptions = {
  INITIAL_SEARCH_QUERY,
  INITIAL_NEW_QUERY,
  dropdownNoOfBeds,
  dropdownNoOfBaths,
  subPropertyOptions,
  listingOptions,
  lotSizeOptions,
  petOptions,
  amenityOptions,
  housingOptions
}

// Defining constants for search box component
export const DEFAULT_SUGGESTIONS = [
  { text: 'Street Number', value: [] },
  { text: 'City', value: [] },
  { text: 'Zip Code', value: [] },
  { text: 'Street Address', value: [] },
  { text: 'MLS', value: [] },
  { text: 'Keyword', value: [] }
]

export const ADDRESS_TEXT_FIELDS = [
  { text: 'City', key: 'City' },
  { text: 'MLS#', key: 'MLSNumber' },
  { text: 'Zip', key: 'PostalCode' }
]

export const SUGGESTED_PARAMS = [
  'street_number',
  'locality',
  'postal_code',
  'route'
]

export const SEARCHED_TEXT_PARAMS = [
  'Cities',
  'Zip Codes',
  'Street Addresses',
  'MLS#'
]

export const STREET_SUFFIXES = [
  'BLVD',
  'LN',
  'DR',
  'AVE',
  'RD',
  'TRL',
  'WAY',
  'PATH',
  'ST',
  'CT',
  'HL',
  'CV',
  'CIR',
  'PL',
  'LOOP',
  'TRCE',
  'RDG',
  'RUN',
  'CYN',
  'PASS',
  'BND',
  'PKWY',
  'HWY',
  'MTN',
  'TER',
  'HOLW',
  'CRK'
]

export const STREET_FULL_SUFFIXES = [
  'Boulevard',
  'Lane',
  'Drive',
  'Avenue',
  'Road',
  'Trail',
  'Way',
  'Path',
  'Street',
  'Court',
  'Circle',
  'Place',
  'Loop',
  'Pass',
  'Heights',
  'Run',
  'Bend',
  'Divide'
]

export const STREET_DIRECTIONS = [
  'East',
  'North',
  'West',
  'South'
]

// TODO: uhhhH??!?!
export const MLS_CITIES = [
  'Austin',
  'Jonestown',
  'Hutto',
  'Lakeway',
  'Harker Heights',
  'San Marcos',
  'Belton',
  'Dripping Springs',
  'Buda',
  'Georgetown',
  'Leander',
  'Manchaca',
  'Manor',
  'Pflugerville',
  'Lampasas',
  'Liberty Hill',
  'Lockhart',
  'Taylor',
  'Cibolo',
  'Round Rock',
  'New Braunfels',
  'Cedar Park',
  'Lago Vista',
  'Kyle',
  'Spicewood',
  'Other',
  'Canyon Lake',
  'Bastrop',
  'Driftwood',
  'Buchanan Dam',
  'Cameron',
  'Wimberley',
  'Fischer',
  'Cedar Creek',
  'Horseshoe Bay',
  'Jarrell',
  'Killeen',
  'Del Valle',
  'Smithville',
  'Burnet',
  'Florence',
  'West Lake Hills',
  'Elgin',
  'Kingsland',
  'Dale'
]

export const HIDE_STATUSES = [
  'Sold',
  'Temporarily Off Market',
  'Withdrawn',
  'Expired',
  'Leased'
]
